/**
 * CLC TA API
 *
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const ApprovalContext = {
    Manager: 'Manager',
    Funding: 'Funding',
    OutOfRegion: 'OutOfRegion',
    Acquittal: 'Acquittal',
    PrePayment: 'PrePayment',
    OverPayment: 'OverPayment',
    Cancellation: 'Cancellation',
    DayTripPayment: 'DayTripPayment',
    SecondaryAcquittal: 'SecondaryAcquittal'
} as const;
export type ApprovalContext = typeof ApprovalContext[keyof typeof ApprovalContext];

